import { InfoCircleOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Modal, Space, Tag, Typography } from 'antd';

export function SpBrowserExitModal({ open = false, onSubmit = undefined, onClose = undefined }) {
  return (
    <ModalComponent visible={open} okText="ยืนยัน" onCancel={onClose} onOk={onSubmit}>
      <Space direction="vertical" align="center">
        <InfoCircleOutlined style={{ color: '#FF0000', fontSize: 50 }} />
        <Typography.Text strong>ยืนยันการออกจากหน้าเพจนี้</Typography.Text>

        <Tag
          style={{
            color: '#fff',
            backgroundColor: '#202735',
            borderColor: '#000',
            marginBottom: 0,
            fontSize: 15,
            padding: '10px 22px',
            lineHeight: '27px',
            textWrap: 'auto',
            textAlign: 'center',
          }}
        >
          คุณยังมีข้อมูลที่ยังไม่ได้บันทึก หากออกจากหน้าเพจนี้แล้ว จะไม่สามารถกลับมาแก้ไขข้อมูลนี้ได้อีก
        </Tag>
        <Typography.Text style={{ fontSize: 11 }}>กรุณาคลิกยืนยันหากท่านต้องการออกจากหน้าเพจนี้</Typography.Text>
      </Space>
    </ModalComponent>
  );
}

const ModalComponent = styled(Modal)({
  '.ant-modal-footer': {
    justifyContent: 'center',
    display: 'flex',
  },
});
